var React = require('react');

function Button (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 8.825) rotate(-90)"},React.createElement("path",{"d":"M2312.744,421.845l-5.087-9.329a1.869,1.869,0,1,0-3.282,1.79l4.61,8.455-4.61,8.455a1.869,1.869,0,1,0,3.282,1.79l5.087-9.329a1.961,1.961,0,0,0,0-1.832Z","transform":"translate(-2304.147 -411.541)","fill":"#282d3d"})));
}

Button.defaultProps = {"focusable":"false","viewBox":"0 0 22.439 8.825"};

module.exports = Button;

Button.default = Button;
